import { INLINE_CODE } from '../constants';
import { InlineCodeElement } from '../types';

/** Create en inline code element */
export function createInlineCode(children: InlineCodeElement['children'] = [{ text: '' }]): InlineCodeElement {
    return { type: INLINE_CODE, children };
}
